<form class="" [formGroup]="formCenters">
    <div class="formInit mt-1 ">
        <div class="row mb-2 mt-2 pr-2 pl-2">
            <div class="col-10">
                <div class="form-group datos_identificacion">
                    <label class=" mt-1 anchurax30  text-right">{{
                                "gestion_terceros.centros.managementBody" | translate  }} :</label>

                    <button (click)="borrar('AdminCenterEReceptorId')"
                        class="btn btn-secondary  float-right  btn-sm ml-1  altura1_5">
                        <i class="k-icon  k-i-edit k-i-pencil"></i>
                    </button>
                    <kendo-dropdownlist formControlName="AdminCenterEReceptorId" [data]="administrativeCenters2"
                        [textField]="'Description'" [valueField]="'ID'" (valueChange)="valueChange($event)"
                        [valuePrimitive]="true" class="form-control anchurax55 float-right">
                        <!-- <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span class="kendo_list_template">{{ dataItem.Description }}</span>
                        </ng-template> -->
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>
        <div class="row mb-2 mt-2 pr-2 pl-2">
            <div class="col-10">
                <div class="form-group datos_identificacion">
                    <label class="anchurax30  mt-1  text-right">{{
                                "gestion_terceros.centros.transactUnit" | translate  }} :</label>
                    <button (click)="borrar('AdminCenterEPayerId')"
                        class="btn btn-secondary  float-right  btn-sm ml-1 altura1_5">
                        <i class="k-icon  k-i-edit k-i-pencil"></i>
                    </button>
                    <kendo-dropdownlist formControlName="AdminCenterEPayerId" [data]="administrativeCenters3"
                        [textField]="'Description'" [valueField]="'ID'" (valueChange)="valueChange($event)"
                        [valuePrimitive]="true" class="form-control anchurax55 float-right">
                        <!-- <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span class="kendo_list_template">{{ dataItem.Description }}</span>
                        </ng-template> -->
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>

        <div class="row mb-2 mt-2 pr-2 pl-2">
            <div class="col-10">
                <div class="form-group datos_identificacion">
                    <label class="anchurax30  mt-1  text-right">{{
                                "gestion_terceros.centros.accountingOffice" | translate  }} :</label>
                    <button (click)="borrar('AdminCenterEFiscalId')"
                        class="btn btn-secondary  float-right  btn-sm ml-1 altura1_5">
                        <i class="k-icon  k-i-edit k-i-pencil"></i>
                    </button>
                    <kendo-dropdownlist formControlName="AdminCenterEFiscalId" [data]="administrativeCenters1"
                        [textField]="'Description'" [valueField]="'ID'" (valueChange)="valueChange($event)"
                        [valuePrimitive]="true" class="form-control anchurax55 float-right">
                        <!-- <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span class="kendo_list_template">{{ dataItem.Description }}</span>
                        </ng-template> -->
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>

        <div class="row mb-2 mt-2 pr-2 pl-2">
            <div class="col-10">
                <div class="form-group datos_identificacion">
                    <label class="anchurax30  mt-1  text-right">{{
                                "gestion_terceros.centros.proposingBody" | translate  }} :</label>
                    <button (click)="borrar('AdminCenterEBuyerId')"
                        class="btn btn-secondary  float-right  btn-sm ml-1 altura1_5">
                        <i class="k-icon  k-i-edit k-i-pencil"></i>
                    </button>
                    <kendo-dropdownlist formControlName="AdminCenterEBuyerId" [data]="administrativeCenters4"
                        [textField]="'Description'" [valueField]="'ID'" (valueChange)="valueChange($event)"
                        [valuePrimitive]="true" class="form-control anchurax55 float-right">
                        <!-- <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span class="kendo_list_template">{{ dataItem.Description }}</span>
                        </ng-template> -->
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>
    </div>
</form>